import PropTypes from 'prop-types'
import React from 'react'

import SEOKEYRUS from '../../keyrus/src/components/seo'
import SEOKF from '../../keyrus-fondation/src/components/seo'
import SEOKLS from '../../keyrus-life-science/src/components/seo'
import SEOKM from '../../keyrus-management/src/components/seo'
import SEONS from '../../keyrus-nearshoring/src/components/seo'

const SEO = ({countryData, pageContext, pageMetaData}) => {
  const envWebsite = process.env.GATSBY_WEBSITE

  const renderSeoComponent = val => {
    switch (val) {
      case 'keyrus':
        return (
          <SEOKEYRUS
            pageContext={pageContext}
            countryData={countryData}
            pageMetaData={pageMetaData}
          />
        )
      case 'kls':
        return (
          <SEOKLS
            pageContext={pageContext}
            countryData={countryData}
            pageMetaData={pageMetaData}
          />
        )
      case 'keyrus-management':
        return (
          <SEOKM
            pageContext={pageContext}
            countryData={countryData}
            pageMetaData={pageMetaData}
          />
        )
      case 'keyrus-china':
        return (
          <SEOKEYRUS
            pageContext={pageContext}
            countryData={countryData}
            pageMetaData={pageMetaData}
          />
        )
      case 'keyrus-fondation':
        return (
          <SEOKF
            pageContext={pageContext}
            countryData={countryData}
            pageMetaData={pageMetaData}
          />
        )
      case 'keyrus-nearshoring':
        return (
          <SEONS
            pageContext={pageContext}
            countryData={countryData}
            pageMetaData={pageMetaData}
          />
        )
      default:
        return null
    }
  }

  return renderSeoComponent(envWebsite)
}

export default SEO

SEO.propTypes = {
  article: PropTypes.bool,
  author: PropTypes.string,
  countryData: PropTypes.node,
  image: PropTypes.string,
  pageContext: PropTypes.node,
}

SEO.defaultProps = {
  article: false,
  author: null,
  countryData: null,
  image: null,
  pageContext: null,
}
